import script from "./AccountInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&setup=true"

import "./AccountInfo.vue?vue&type=style&index=0&id=414d88b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414d88b0"]])

export default __exports__